'use strict';

angular.module('dekky.forms.themes.bootstrap')
	.run(function ($templateCache) {
		$templateCache.put('/dekky.forms/themes/bootstrap/fields/uiDatepicker.html',
			'<p class="input-group">' +
				'<input type="text" class="form-control" name="{{ field.name }}" id="{{ field.name }}" ng-model="model" uib-datepicker-popup="{{ field.format }}" is-open="popup.opened" datepicker-options="field.dateOptions" close-text="Close" />' +
				'<span class="input-group-btn">' +
					'<button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button>' +
				'</span>' +
			'</p>'
		);
	});